module.exports = __webpack_public_path__ + "static/media/icon-refresh.7b7a459f.svg";